import {safeStorage} from "../safe-storage"

const store = safeStorage("local")

export default {
  mounted() {
    const saved = store.getItem("show_epm")
    const show = saved === null ? true : saved === "true"
    this.pushEvent("set_epm_preference", { show })
    this.handleEvent("epm_toggled", ({ show }) => {
      store.setItem("show_epm", show.toString())
    })
  }
}
